import styled, { keyframes } from 'styled-components';

const rotateAnim = keyframes`
  0% {
    transform: rotate(90deg);
  }

  50%, 100% {
    transform: rotate(0deg);
  }
`;

export const SVG = styled.svg`
  animation: ${rotateAnim} 1.5s ${props => props.theme.transition.easeInOut}
    alternate infinite;
  fill: ${props => props.theme.colors.quaternary};
  height: 50px;
  position: relative;
  transform: rotate(90deg);
  width: 40px;
`;

export const Text = styled.p`
  font-size: ${props => props.theme.fonts.baseSize};
  position: relative;
`;

const MobileLandscapeNote = styled.section`
  display: none;

  @media screen and (orientation: landscape) and (max-width: ${props =>
      props.theme.breakpoints.md}) {
    background: ${props => props.theme.colors.tertiary};
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: ${props => props.theme.zIndex.overlay};
  }
`;

export default MobileLandscapeNote;



// WEBPACK FOOTER //
// ./src/components/atoms/MobileLandscapeNote/MobileLandscapeNote.styled.js